const USERS_PENDING = 'users_pending';
const USERS_FAILED = 'users_failed';
const USERS_DOWNLOADED = 'users_downloaded';
const USERS_RESET = 'users_reset';
const USER_LOGIN = 'user_login';
const USER_SENDING = 'user_sending';
const USER_DOWNLOADED = 'user_downloaded';
const USERS_RENTERS_DOWNLOADED = 'users_renters_downloaded';
const WAITING_USERS_DOWNLOADED = 'waiting_users_downloaded';
const WAITING_USER_DOWNLOADED = 'waiting_user_downloaded';
const WAITING_USER_REMOVED = 'waiting_user_removed';
const WAITING_USERS_PENDING = 'waiting_users_pending';
const USER_RENTER_REMOVED = 'user_renter_removed';

export {
  USERS_PENDING,
  USERS_FAILED,
  USERS_DOWNLOADED,
  USERS_RESET,
  USER_LOGIN,
  USER_SENDING,
  USER_DOWNLOADED,
  USERS_RENTERS_DOWNLOADED,
  WAITING_USERS_DOWNLOADED,
  WAITING_USER_DOWNLOADED,
  WAITING_USER_REMOVED,
  WAITING_USERS_PENDING,
  USER_RENTER_REMOVED,
};



// WEBPACK FOOTER //
// ./src/store/users/types.js